define(function () {
	const builder = require('civicsUtils/buildUrlParameters');
	const IPSModelCollection = require('civicsBase/ipsModelCollection');
	const utils = require('civicsUtils/general_utilities');

	return IPSModelCollection.extend({
		urlRoot: '/delegate/civics-api/api/portal/myinstruments',
		url: function () {
			var parameters = '';

			let parms = {
				compatiblemode: true,
				includefees:true
			}
			if (this.urlParameters != undefined) {
				this.urlParameters.passThroughObject = $.extend({}, this.urlParameters.passThroughObject, parms);
				parameters = builder.buildUrlParameters(this.urlParameters);
			}
			var ret = this.urlRoot + parameters;

			return ret;
		},
		modelId: function (attrs) {
			return attrs.instrumentType + '_' + attrs.id;
		},
		parse: function (response) {
			var data = response.data;

			for (i = 0; i < data.length; i++) {
				data[i] = this.processInstrument(data[i]);
			}			
			return data;
		},

		processInstrument: function (instrument, includedInstrument) {
			//we need to keep the instrument data so the instrument count is accurate, or else our paging breaks. 
			//we do not want to display instruments with bad data, however. So we set a bool and check it before rendering it in the paging view.
			instrument.hideFromPagingView = !instrument.fees || instrument.fees.length == 0;

			switch (instrument.instrumentType.toLowerCase()) {
				case 'buildingapplication':
					instrument._cdrType = 'building';
					break;
				case 'businesslicense':
					instrument._cdrType = 'businesslicense';
					break;
				case 'case':
					instrument._cdrType = 'codeenforcement';
					break;
				case 'planningapplication':
					instrument._cdrType = 'planning';
					break;
				case 'projectapplication':
					instrument._cdrType = 'project';
					break;
				case 'tradelicense':
					instrument._cdrType = 'tradelicense';
					break;
				case 'useapplication':
					instrument._cdrType = 'use';
					break;
				default:
					console.log('undefined/invalid product family from the instrument response');
			}

			//COMMON
			instrument.applicationName = instrument.instrumentName;
			instrument.addedDate = instrument.addedDateTime;
			instrument.unpaidFees = instrument.totalUnpaidFees;

			if (includedInstrument) {
				if (instrument.applicationType) {
					instrument.description = instrument.applicationType.description;
					instrument.portalDescription = instrument.applicationType.portalDescription;
				}
				instrument.instrumentNumber = instrument.applicationNumber
				instrument.totalUnpaidFees = instrument.totalUnpaidAmount
			}
			instrument.sortDescription = instrument.portalDescription && instrument.portalDescription.trim() != "" ? instrument.portalDescription : instrument.description;

			//For X/Y primary site values
			if(instrument.Spatial && _.isEmpty(instrument.locationLine1))
			{
				instrument.locationLine1 = 'x: ' + instrument.Spatial.xCoordinate;
				instrument.locationLine2 = 'y: ' + instrument.Spatial.yCoordinate;
			}

			$.each(instrument.fees, (index, fee) => {
				if (fee.feeGroupCode.trim() == "") {
					fee.feeGroupCode = '__generalFees';
					fee.feeGroupDescription = i18n.t('CIVICS.MY_FEES_LIST.LIST.GENERAL_FEES_GROUP');
				}
				if (fee.feeGroupDescription.trim() == "") {
					fee.feeGroupDescription = i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
				}
				fee.feeSelected = false;
			});	
			$.each(instrument.includedInstruments, (index, child) => {
				child = this.processInstrument(child, true);
				//check if there are fees on the child. if there are, then we need to show this record regardless of
				//if there are fees directly on it or not.
				if(child.hideFromPagingView === false){
					instrument.hideFromPagingView = false;
				}
			})
			this.sortFees(instrument.fees);
			this.sortChildInstruments(instrument.includedInstruments);
			//we don't use the ID for anything directly, however for some reason the collection is ignoring our "modelId" funciton above, and the ID at run time is unchanged.
			//Because the IDs can be the same across product families we're going to alter the ID to be unique.
			instrument.original_id = instrument.id;
			instrument.id = instrument._cdrType + '_' + instrument.id;
			return instrument;
		},
		sortFees(fees) {
			if (fees) {
				fees.sort((a, b) => {
					if (!this.ignoreFeeGroupsWhenSorting){
					//first sort by group. This will result in the groups being sorted when displayed.
					let aGroup = a.feeGroupDescription;
					let bGroup = b.feeGroupDescription;
					if (aGroup < bGroup) return -1;
						if (aGroup > bGroup) return 1;
					}
					//if we're in the same group(or ignoring groups altogether), then sort by fee description.
					let aDescription = a.portalDescription ? a.portalDescription.trim() : a.description ? a.description.trim() : '';
					let bDescription = b.portalDescription ? b.portalDescription.trim() : b.description ? b.description.trim() : '';
					if (aDescription < bDescription) return -1;
					if (aDescription > bDescription) return 1;
					return 0;
				});
			}
		},
		sortChildInstruments(childInstruments) {
			if (childInstruments
				&& this.urlParameters
				&& this.urlParameters.orderBy
				&& this.urlParameters.orderBy.length > 0) {
				let orderByParameter = this.urlParameters.orderBy[0].Property.toLowerCase();
				//1 for ascending, -1 for descending. used inside the sort.
				let ascDesc = this.urlParameters.orderBy[0].direction == 'asc' ? 1 : -1;
				let sortParameters = [];
				if (orderByParameter == 'property.propertyname') {
					sortParameters = ['locationLine1', 'sortDescription', 'instrumentNumber'];
				} else if (orderByParameter == 'instrumentdescription') {
					sortParameters = ['sortDescription', 'locationLine1', 'instrumentNumber'];
				} else if (orderByParameter == 'instrumentnumber') {
					sortParameters = ['instrumentNumber'];//there is always a unique instrument number. do not need further sorting.
				} else {
					console.log('Unknown order by, not sorting child instruments.');
				}
				childInstruments.sort((a, b) => {
					let ret = 0;
					for (let i = 0; ret == 0 && i < sortParameters.length; i++) {
						let aSort = a[sortParameters[i]];
						let bSort = b[sortParameters[i]];
						if (aSort < bSort) ret = -1;
						if (aSort > bSort) ret = 1;
					}
					//ascDesc will flip the sort order if we are sorting descending.
					return ret * ascDesc;
				})
			}
		}
	});
});
